// Debug utility functions

// For API call tracking
const apiCalls: Record<string, number> = {};

/**
 * Tracks API calls to identify potential duplicates
 * @param endpoint The API endpoint being called
 * @param params Optional parameters for the call
 */
export const trackApiCall = (endpoint: string, params?: any): void => {
  const key = params ? `${endpoint}:${JSON.stringify(params)}` : endpoint;
  
  if (!apiCalls[key]) {
    apiCalls[key] = 0;
  }
  
  apiCalls[key]++;
  
  // Log in development only
  if (process.env.NODE_ENV === 'development') {
    console.group(`🔄 API Call Tracked: ${endpoint}`);
    console.log(`Call count: ${apiCalls[key]}`);
    if (params) {
      console.log('Parameters:', params);
    }
    console.log('Stack trace:', new Error().stack);
    console.groupEnd();
  }
};

/**
 * Gets the current API call counts
 * @returns The current API call counts
 */
export const getApiCallCounts = (): Record<string, number> => {
  return { ...apiCalls };
};

/**
 * Resets the API call tracking
 */
export const resetApiCallTracking = (): void => {
  Object.keys(apiCalls).forEach(key => {
    delete apiCalls[key];
  });
}; 